export const FreeRoundsTypes = {
  FETCH_FREE_ROUNDS_REJECT: "FETCH_FREE_ROUNDS_REJECT",
  SET_FREE_ROUNDS_REJECTED: "SET_FREE_ROUNDS_REJECTED",
  FETCH_FREE_ROUNDS_DETAILS: "FETCH_FREE_ROUNDS_DETAILS",
  SET_FREE_ROUNDS_DETAILS: "SET_FREE_ROUNDS_DETAILS",
};
